<template>
  <div class="transaction-check-list">
    <div v-for="(transaction, index) in transactionList" :key="index" class="transaction-row">
      <div class="transaction-row-content" v-on:click="toggleCheck(transaction)">
        <div class="transaction-details">
          <div class="business-name">{{ transaction.businessName }}</div>
          <div class="amount">
            <span>{{ formatAmount(transaction.amount) }}</span>
            <span>₪</span>
          </div>
        </div>
        <div class="checkbox">
          <div v-if="!transaction.isChecked" class="circle" :class="{ 'checked': transaction.isChecked }"/>
          <img v-else :src="require('@/assets/icons/icon-check-blue.svg')">
        </div>
      </div>
      <div class="separator-wrapper">
        <separator/>
      </div>
    </div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import moneyUtils from '../../utils/money';

export default {
  name: 'TransactionCheckList',
  components: {
    Separator: BaseUI.Separator,
  },
  props: {
    transactionList: {
      type: Array,
      required: true,
    },
    toggleCheck: {
      type: Function,
      required: true,
    },
  },
  computed: {
  },
  methods: {
    formatAmount(amount) {
      return moneyUtils.formatAmountWithFraction(amount, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../node_modules/base-ui/src/scss/riseup-colors';
@import '../../scss/mixins';

.transaction-check-list {
  background-color: $riseup_gray_-1;

  .transaction-row {
    .transaction-row-content {
      @include responsive-padding;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .transaction-details {
        margin: 15px 0;
        .business-name {
          font-size: 12px;
          margin-bottom: 10px;
        }
        .amount {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 5px;
        }
      }

      .checkbox {
        display: flex;
        align-items: center;

        .circle {
          display: inline-block;
          height: 32px;
          width: 32px;
          vertical-align: middle;
          text-align: center;
          border-radius: 50%;
          border: 1px solid $riseup_gray_2;
          background-color: $riseup_white;
        }
      }
    }

    &:last-child {
    .separator-wrapper {
        padding: 0;
      }
    }
    .separator-wrapper {
      padding: 0 15px;
    }
  }
}
</style>
